<tg-row>
  <tg-col md="9" sm="12">
    <tg-row>
      @if (!isSummaryStep) {
        <tg-col md="6" sm="12">
          <button tgButton2 tgStyle="primary" class="property-page-footer__margin-right"
            (click)="onContinueTo()">
            Continue to {{ continueToTitle$ | async }}
          </button>
          @if (!isEditOrRelistPage) {
<tm-start-over-button [disabled]="
                        (isLoadingEmitter$ | async) ||
                        (listingActionLoading$ | async) ||
                        (listingActionResponse$ | async)?.success">
            </tm-start-over-button>
          }
        </tg-col>
      }

      @if (isSummaryStep && isEditOrRelistPage) {
        <tg-col md="6" sm="12"
          class="property-page-footer__summary-save-change">
          @if (isUpgradePackage || isIncreasePricingTier) {
            <button tgButton2 [tgStyle]="isEnoughBalance ? 'secondary' : 'primary'" (click)="onShowTopUpModal(true)"
                    class="property-page-footer__summary-save-change--button" [disabled]="
                        (listingActionLoading$ | async) ||
                        (listingActionResponse$ | async)?.success
                    ">
              Top up my account
            </button>
          }
          @if (isRelistPage) {
            <button (click)="onEditOrRelistListing()" tgButton2 tgStyle="primary"
                    class="property-page-footer__summary-topup--button" [disabled]="
                        !createOrEditOrRelistListingEnabled ||
                        (listingActionLoading$ | async) ||
                        (listingActionResponse$ | async)?.success ||
                        (!isAgent && !isEnoughBalance)
                    " [tgLoading]="listingActionLoading$ | async">
              Start my listing
            </button>
          }
          @if (isEditPage) {
            <button (click)="onEditOrRelistListing()" tgButton2 tgStyle="primary"
                    class="property-page-footer__summary-topup--button" [disabled]="
                        !createOrEditOrRelistListingEnabled ||
                        (listingActionLoading$ | async) ||
                        (listingActionResponse$ | async)?.success ||
                        (!isAgent && !isEnoughBalance)
                    " [tgLoading]="(listingActionLoading$ | async) === true">
              Update my listing
            </button>
          }
        </tg-col>
      }

      @if (isSummaryStep && !isEditOrRelistPage) {
        <tg-col md="6" sm="12"
          class="property-page-footer__summary-topup">
          @if (!isAgent) {
            <button tgButton2 [tgStyle]="shouldTopUp ? 'primary' : 'secondary'" (click)="onShowTopUpModal(true)"
                    class="property-page-footer__summary-topup--button" [disabled]="
                        (listingActionLoading$ | async) ||
                        (listingActionResponse$ | async)?.success
                    ">
              Top up my account
            </button>
          }
          <button tgButton2 tgStyle="primary" class="property-page-footer__summary-create-listing--button"
                    (click)="onCreateListing()" [disabled]="
                        !createOrEditOrRelistListingEnabled ||
                        (listingActionResponse$ | async)?.success
                    " [tgLoading]="listingActionLoading$ | async">
            Start my listing
          </button>
        </tg-col>
      }

      @if (!isEditOrRelistPage) {
<tg-col md="4" sm="12" [ngClass]="{
                    'property-page-footer__save-and-complete-later--centre':
                        isCompact
                }">
          <button tgButton2 linkStyle class="property-page-footer__save-and-complete-later"
                    (click)="onSaveAndCompleteLater()" [disabled]="
                        (isLoadingEmitter$ | async) ||
                        (listingActionLoading$ | async) ||
                        (listingActionResponse$ | async)?.success">
            Save and exit
          </button>
        </tg-col>
      }
    </tg-row>
  </tg-col>
</tg-row>

@if (isCreditAccountModalVisible) {
  <tg-modal (close)="onShowTopUpModal(false)"
    class="property-page-footer__credit-account-modal" fullscreen>
    <tmp-credit-account (cancelled)="onShowTopUpModal(false)" (creditAdded)="onCreditAdded()"
      (topupFailed)="onCreditFailure()">
    </tmp-credit-account>
  </tg-modal>
}